<script>
export default {
  methods: {
    getDurationString: function (duration, unit = 'seconds') {
      duration = this.moment.duration(duration, unit)
      let durationString = ''
      if (duration.get('hours') > 0) {
        durationString += `${this.withLeadingZero(duration.get('hours'))}:`
      }

      return `${durationString}${this.withLeadingZero(duration.get('minutes'))}:${this.withLeadingZero(duration.get('seconds'))}`
    },
    getRelativeTimeString: function (duration, unit = 'seconds') {
      duration = this.moment.duration(duration, unit)
      let str = ''
      if (duration.get('years')) {
        let years = this.withLeadingZero(duration.get('years'))
        str += ` ${years}${this.$t('time.years')}`
      }
      if (duration.get('months')) {
        let months = this.withLeadingZero(duration.get('months'))
        str += ` ${months}${this.$t('time.months')}`
      }
      if (duration.get('days')) {
        let days = this.withLeadingZero(duration.get('days'))
        str += ` ${days}${this.$t('time.days')}`
      }
      if (duration.get('hours')) {
        let hours = this.withLeadingZero(duration.get('hours'))
        str += ` ${hours}${this.$t('time.hours')}`
      }
      if (duration.get('minutes')) {
        let minutes = this.withLeadingZero(duration.get('minutes'))
        str += ` ${minutes}${this.$t('time.min')}`
      }
      if (duration.get('seconds')) {
        let seconds = this.withLeadingZero(duration.get('seconds'))
        str += ` ${seconds}${this.$t('time.sec')}`
      }

      return str || this.getDefaultRelativeTimeString()
    },
    getDefaultRelativeTimeString: function () {
      return `00 ${this.$t('time.min')} 00 ${this.$t('time.sec')}`
    },
    withLeadingZero: function (n) {
      return n < 10 ? '0' + n : n
    },
  }
}
</script>
